import React from 'react';
import PropTypes from 'prop-types';

import DnDDraggableItem from './DnDDraggableItem';


function AnswerOptions({component_data}) {
    function getDroppableStyle() {
        return {
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            // justifyContent: "center",
            minWidth: "100px",
            minHeight: "100px",
            padding: "0",
            background: "transparent",
            ..._.get(component_data, 'data.option_droppable_style')
        }
    }

    function renderOptions() {
        const answerOptions = _.get(component_data, 'data.answer_options');

        return answerOptions.map((item, key) => {
            return (
                <div key={key}>
                    <DnDDraggableItem item={item}/>
                </div>
            );
        });
    }

    return (
        <div style={getDroppableStyle()}>
            <div className="cc-dndpuzzle-answer-options">
                <div className="d-flex flex-gap-10">
                    {renderOptions()}
                </div>
            </div>
        </div>
    );
}

AnswerOptions.propTypes = {
    component_data: PropTypes.shape({
        data: PropTypes.shape({
            answer_options: PropTypes.array.isRequired,
            option_droppable_style: PropTypes.object,
        }).isRequired
    }).isRequired
}

export default AnswerOptions